import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

// Models
import { User } from 'src/app/modules/account/models/user';

// Services
import { UiService } from 'src/app/platform/services/ui.service';
import { InvoicesService } from 'src/app/modules/invoices/invoices.service';
import { UserService } from 'src/app/modules/account/user.service';
import { AccountsService } from 'src/app/modules/account/accounts.service';
import { PaymentGenerateData } from '../../models/payments';
import { PaymentsService } from '../../payments.service';

@Component({
  selector: 'app-pay-modal',
  templateUrl: './pay-modal.component.html',
  styleUrls: ['./pay-modal.component.scss']
})
export class PayModalComponent implements OnInit {
  public isPaymentStatus = false;
  public cancelUnsuscribe = false;
  public paymentMethod: 'mercadopago'|'pagos360';

  public type = 'all';

  constructor(
    private dialog: MatDialogRef<PayModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { amount: number, receipts: Array<PaymentGenerateData> },
    private uiService: UiService,
    private userService: UserService,
    private invoicesService: InvoicesService,
    private paymentsService: PaymentsService,
    private accountsService: AccountsService,
  ) {
    this.userService.currentUser.subscribe((user: User) => {
      this.isPaymentStatus = (user.isPaymentStatus() && (user.status === 'BajaMoroso' || user.status === 'BajaPendiente'));
    });
  }

  ngOnInit(): void {
    console.log(this.data);
    this.type = this.data !== null ? 'custom' : 'all';
  }

  onCancel(): void {
    this.dialog.close();
  }

  onSend(): void {
    if(['mercadopago', 'pagos360'].includes(this.paymentMethod)){
      this.uiService.showSpinner(true);

      let call: Promise<any>;
      
      if(this.type === 'custom'){
        call = this.paymentsService.paymentGenerate(this.paymentMethod, this.data.receipts, this.cancelUnsuscribe);
      } else {
        call = this.invoicesService.invoicesPayAll(this.paymentMethod, this.cancelUnsuscribe);
      }
      
      call.then((payment) => {
        this.uiService.showSpinner(false);
  
        if (payment.result.initPoint !== '') {
          window.open(payment.result.initPoint, '_blank');
          this.accountsService.accountsDataUpdate();
  
          this.uiService.dialogShow('', 'Se abrirá una nueva pestaña para que puedas realizar el pago. Si no se abre automaticamente podes hacer el pago mediante el siguiente enlace:<br><br><p><a href="' + payment.result.initPoint + '" target="_blank">Abrir ventana de pago</a></p>', 'success');
        } else {
          this.uiService.dialogShow('Ups!', 'No es posible realizar el pago en este momento (#0002). Estamos trabajando para solucionar el inconveniente.', 'alert');
        }
      }).catch(() => {
        this.uiService.showSpinner(false);
        this.uiService.dialogShow('Ups!', 'No es posible realizar el pago en este momento (#0001). Estamos trabajando para solucionar el inconveniente.', 'alert');
      });      
    } else {
      this.uiService.dialogShow('', 'Es necesario seleccionar un medio de pago.', 'alert');
    }
  }
}
